(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2952],{

/***/ 97968:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/help/[...support]",
      function () {
        return __webpack_require__(80789);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SupportPagesQuery; },
/* harmony export */   "j": function() { return /* binding */ SupportPageQuery; }
/* harmony export */ });
/* harmony import */ var groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57831);
/* harmony import */ var groq_shared_LocaleSeo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16138);
/* harmony import */ var groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1809);



// NOTE: Temporaily using pulling in aviailableFrom/availableTo Twice to support existing sidebar setup
// Needs additional Investigation
var SupportPageQuery = '\n*[_type == "SupportPage" && url.current == $supportUrl && country == $country][0] {\n  _id,\n  _type,\n  title,\n  '.concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("localeTitle"), ',\n  "onlineFrom": availableFrom,\n  "onlineTo": availableTo,\n  availableFrom,\n  availableTo,\n  ').concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_0__/* .LocalePortableText */ .O)("content"), ",\n  ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_0__/* .LocalePortableText */ .O)("localeContent"), ",\n  ").concat((0,groq_shared_LocalePortableText__WEBPACK_IMPORTED_MODULE_0__/* .LocalePortableText */ .O)("sidebarContent"), ",\n  generateSidebarNavigation,\n  ").concat((0,groq_shared_LocaleSeo__WEBPACK_IMPORTED_MODULE_2__/* .LocaleSeo */ .U)("seo"), ",\n}");
var SupportPagesQuery = '\n*[_type == "SupportPage"][country == $country\n  && (\n    !defined(availableOn)\n    || availableOn == "all"\n    || availableOn == $platform\n    || $platform == ""\n  )\n] {\n  _id,\n  _type,\n  title,\n  '.concat((0,groq_shared_LocaleString__WEBPACK_IMPORTED_MODULE_1__/* .LocaleString */ .E)("localeTitle"), ',\n  "url": url.current,\n  availableFrom,\n  availableTo,\n}\n');


/***/ }),

/***/ 80789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_getContentInputQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52938);
/* harmony import */ var utils_isContentOnline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89996);
/* harmony import */ var ui_pages_SupportPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66895);
/* harmony import */ var hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95967);
/* harmony import */ var groq_pages_SupportPage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77243);
/* harmony import */ var ui_components_NoSearchResults__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20769);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79758);













var HelpPages = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var supportPage = router.query.support;
    var supportUrl = "/help/".concat(supportPage.join("/"));
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_5__/* .useGroqQuery */ .Mo)({
        operationName: "SupportPage",
        query: groq_pages_SupportPage__WEBPACK_IMPORTED_MODULE_6__/* .SupportPageQuery */ .j,
        variables: {
            supportUrl: supportUrl
        }
    }), 1), pageQuery = ref6[0];
    var isPageOnline = (0,utils_isContentOnline__WEBPACK_IMPORTED_MODULE_10__/* .isContentOnline */ .e)({
        onlineFrom: (ref = pageQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.availableFrom,
        onlineTo: (ref2 = pageQuery.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.content) === null || ref3 === void 0 ? void 0 : ref3.availableTo
    }, (0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_5__/* .groqPreviewInput */ .i8)(router.query));
    if (!((ref4 = pageQuery.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.content) === null || ref5 === void 0 ? void 0 : ref5._id) && !pageQuery.fetching && !pageQuery.stale || !isPageOnline) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_NoSearchResults__WEBPACK_IMPORTED_MODULE_7__/* .NoSearchResults */ .qx, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_pages_SupportPage__WEBPACK_IMPORTED_MODULE_4__/* .SupportPage */ .P, {
        supportPageQuery: pageQuery
    });
};
if (utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .isServer */ .sk) {
    HelpPages.getInitialProps = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(context) {
            var ref, ref1, ref2, supportPage, supportUrl, SupportPage, _tmp, ref3, data, isPageOnline, _tmp1, _tmp2, _tmp3;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        supportPage = context.query.support;
                        supportUrl = "/help/".concat(supportPage.join("/"));
                        _tmp = {};
                        SupportPage = context.urqlClient.query((0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_5__/* .CONTENT_QUERY */ .lK)("SupportPage"), (0,utils_getContentInputQuery__WEBPACK_IMPORTED_MODULE_3__/* .getContentInputQuery */ ._)((_tmp.query = groq_pages_SupportPage__WEBPACK_IMPORTED_MODULE_6__/* .SupportPageQuery */ .j, _tmp.params = {
                            supportUrl: supportUrl
                        }, _tmp.context = context, _tmp)));
                        return [
                            4,
                            Promise.all([
                                SupportPage
                            ])
                        ];
                    case 1:
                        ref3 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), data = ref3[0].data;
                        _tmp1 = {};
                        isPageOnline = (0,utils_isContentOnline__WEBPACK_IMPORTED_MODULE_10__/* .isContentOnline */ .e)((_tmp1.onlineFrom = data === null || data === void 0 ? void 0 : (ref = data.content) === null || ref === void 0 ? void 0 : ref.availableFrom, _tmp1.onlineTo = data === null || data === void 0 ? void 0 : (ref1 = data.content) === null || ref1 === void 0 ? void 0 : ref1.availableTo, _tmp1), (0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_5__/* .groqPreviewInput */ .i8)(context.query));
                        _tmp2 = {};
                        if (!(data === null || data === void 0 ? void 0 : (ref2 = data.content) === null || ref2 === void 0 ? void 0 : ref2._id) || !isPageOnline) {
                            if (context.res) context.res.statusCode = 404;
                            return [
                                2,
                                _tmp2
                            ]; // Fall through to allow client-side 404 page to render
                        }
                        _tmp3 = {};
                        // return an object that a non-empty to prevent "returned an empty object" error in logs
                        return [
                            2,
                            (_tmp3.emptyProps = true, _tmp3)
                        ];
                }
            });
        });
        return function(context) {
            return _ref.apply(this, arguments);
        };
    }();
}
/* harmony default export */ __webpack_exports__["default"] = (HelpPages);


/***/ }),

/***/ 66895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SupportPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88038);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57178);
/* harmony import */ var _sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12601);
/* harmony import */ var ui_components_Page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87150);
/* harmony import */ var ui_elements_Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68302);
/* harmony import */ var utils_serializeBlockContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88313);
/* harmony import */ var hooks_a11y__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71129);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77480);
/* harmony import */ var ui_components_PageHead__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9294);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20368);
/* harmony import */ var ui_components_CustomerSupportBanner__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54969);
/* harmony import */ var hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95967);
/* harmony import */ var groq_pages_SupportPage__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(77243);
/* harmony import */ var hooks_usePromotionView__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(32736);




















var MobileNav = function(param) {
    var supportPageIndex = param.supportPageIndex, linkQueryString = param.linkQueryString, onClick = param.onClick, sidebarContent = param.sidebarContent;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isDropdownOpen = ref2[0], setDropdownOpen = ref2[1];
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_10__/* .useTranslate */ .qM)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,hooks_a11y__WEBPACK_IMPORTED_MODULE_9__/* .useDialogDismiss */ .sH)({
        ref: ref3,
        handler: function() {
            return setDropdownOpen(false);
        }
    });
    (0,hooks_a11y__WEBPACK_IMPORTED_MODULE_9__/* .useFocusTrap */ .P5)({
        ref: ref3,
        isActive: isDropdownOpen
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:hidden",
        "data-test-id": "support-page-mobile-nav",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md:hidden flex items-center bg-puma-black-700 p-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                id: "support-page-nav-dropdown-title",
                                className: "font-bold flex-grow px-4",
                                children: t("supportPagesDropdownTitle")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zxk, {
                                name: t("supportPagesDropdownTitle"),
                                "aria-haspopup": "true",
                                "aria-expanded": isDropdownOpen,
                                "aria-controls": "support-page-nav-dropdown",
                                "data-test-id": "support-page-nav-dropdown-button",
                                className: "bg-puma-black-800 p-2 rounded-sm",
                                onClick: function() {
                                    setDropdownOpen(!isDropdownOpen);
                                },
                                label: isDropdownOpen ? "support pages dropdown is open" : "support pages dropdown is closed",
                                icon: isDropdownOpen ? "subtract" : "add",
                                mode: "icon"
                            })
                        ]
                    }),
                    isDropdownOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": "support-page-nav-dropdown-title",
                        tabIndex: -1,
                        id: "support-page-nav-dropdown",
                        "data-test-id": "support-page-nav-dropdown",
                        className: "bg-puma-black-800 p-6 divide-y",
                        children: (ref = supportPageIndex.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                            var _id = param._id, title = param.title, url = param.url, localeTitle = param.localeTitle;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
                                    onClick: function(e) {
                                        onClick === null || onClick === void 0 ? void 0 : onClick(e);
                                        setDropdownOpen(false);
                                    },
                                    className: "font-bold block py-2",
                                    href: "".concat(url).concat(linkQueryString),
                                    children: localeTitle || title
                                })
                            }, _id);
                        })
                    }, "support-page-nav-dropdown")
                ]
            }),
            sidebarContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-2 p-2 bg-puma-black-800",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_4___default()), {
                    blocks: sidebarContent,
                    serializers: utils_serializeBlockContent__WEBPACK_IMPORTED_MODULE_8__/* .serializeTocBlockContent */ .lw
                })
            })
        ]
    });
};
var DesktopNav = function(param) {
    var headers = param.headers, supportPageIndex = param.supportPageIndex, linkQueryString = param.linkQueryString, onClick = param.onClick, sidebarContent = param.sidebarContent, currentSupportPage = param.currentSupportPage;
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "hidden md:block space-y-6 pr-6 border-r-2",
        "data-test-id": "support-page-desktop-nav",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: (ref = supportPageIndex.data) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                        var _id = param._id, title = param.title, url = param.url, localeTitle = param.localeTitle;
                        var isActive = _id === currentSupportPage;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
                                className: "font-bold hover:underline ".concat(isActive ? "underline" : ""),
                                href: "".concat(url).concat(linkQueryString),
                                onClick: onClick,
                                children: localeTitle || title
                            })
                        }, _id);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "hidden md:block",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_4___default()), {
                        renderContainerOnSingleChild: true,
                        blocks: headers,
                        serializers: utils_serializeBlockContent__WEBPACK_IMPORTED_MODULE_8__/* .serializeHeaderToList */ .A5
                    })
                })
            }),
            sidebarContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_sanity_block_content_to_react__WEBPACK_IMPORTED_MODULE_4___default()), {
                blocks: sidebarContent,
                serializers: utils_serializeBlockContent__WEBPACK_IMPORTED_MODULE_8__/* .serializeTocBlockContent */ .lw
            })
        ]
    });
};
var Integration = function(param) {
    var type = param.type;
    switch(type){
        case "yext":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                            src: "https://answers-embed.us.puma.com.pagescdn.com/iframe-prod.js"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "answers-container"
                    })
                ]
            });
        default:
            return null;
    }
};
var SupportPage = function(param) {
    var supportPageQuery = param.supportPageQuery, onLinksClick = param.onLinksClick;
    var ref, ref1, ref2;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_10__/* .useTranslate */ .qM)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var localizeUrlPath = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_12__/* .useSiteConfig */ .N)().localizeUrlPath;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_14__/* .useGroqQuery */ .Mo)({
        operationName: "SupportPages",
        query: groq_pages_SupportPage__WEBPACK_IMPORTED_MODULE_15__/* .SupportPagesQuery */ .U,
        variables: {
            platform: "web"
        }
    }), 1), supportPageIndex = ref3[0];
    var supportPage = supportPageQuery === null || supportPageQuery === void 0 ? void 0 : (ref = supportPageQuery.data) === null || ref === void 0 ? void 0 : ref.content;
    var ref4, ref5;
    var supportPageContent = (ref5 = (ref4 = supportPage === null || supportPage === void 0 ? void 0 : supportPage.localeContent) !== null && ref4 !== void 0 ? ref4 : supportPage === null || supportPage === void 0 ? void 0 : supportPage.content) !== null && ref5 !== void 0 ? ref5 : [];
    var headers = (supportPage === null || supportPage === void 0 ? void 0 : supportPage.generateSidebarNavigation) ? supportPageContent === null || supportPageContent === void 0 ? void 0 : supportPageContent.filter(function(block) {
        return "style" in block && block.style && /^h\d/.test(block.style);
    }) : [];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(router.asPath.split("?"), 2), queryString = ref6[1];
    var qs = new URLSearchParams(queryString);
    var showMinimalNav = qs.has("minimal");
    var returnUrl = localizeUrlPath("/");
    var returnText = t("home");
    if (qs.get("return") === "livechat") {
        returnUrl = localizeUrlPath("/live-chat");
        returnText = t("returnToChat");
    }
    var linkQueryString = queryString ? "?".concat(queryString) : "";
    var supportPageRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var gaTrackData = {
        id: "",
        name: "",
        creative: "TermsAndConditions"
    };
    (0,hooks_usePromotionView__WEBPACK_IMPORTED_MODULE_16__/* .usePromotionView */ .Y)(supportPageRef, gaTrackData, true);
    var pageTitle = t("pageTitleReduced", {
        title: (supportPage === null || supportPage === void 0 ? void 0 : (ref1 = supportPage.seo) === null || ref1 === void 0 ? void 0 : ref1.pageTitles) || (supportPage === null || supportPage === void 0 ? void 0 : supportPage.localeTitle) || (supportPage === null || supportPage === void 0 ? void 0 : supportPage.title) || ""
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: supportPageRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_PageHead__WEBPACK_IMPORTED_MODULE_11__/* .PageHead */ .y, {
                title: pageTitle,
                description: supportPage === null || supportPage === void 0 ? void 0 : (ref2 = supportPage.seo) === null || ref2 === void 0 ? void 0 : ref2.pageDescriptions
            }),
            showMinimalNav && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "data-test-id": "support-page-minimal-nav",
                className: "mobile:p-4 tablet:p-6 desktop:p-8 border-b-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: returnUrl,
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO$, {
                            name: "chevron-left",
                            size: "2xl"
                        }),
                        returnText
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Page__WEBPACK_IMPORTED_MODULE_6__/* .Page */ .T, {
                query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, supportPageQuery), {
                    fetching: supportPageQuery.fetching || supportPageQuery.stale
                }),
                children: supportPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full max-w-screen-xl mx-auto grid gap-6 md:gap-10 lg:gap-16 md:grid-cols-12 xl:pt-4 xl:pb-16",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                            "aria-label": "Support page navigation",
                            className: "md:col-span-4 lg:col-span-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileNav, {
                                    supportPageIndex: supportPageIndex,
                                    linkQueryString: linkQueryString,
                                    onClick: onLinksClick,
                                    sidebarContent: supportPage === null || supportPage === void 0 ? void 0 : supportPage.sidebarContent
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopNav, {
                                    headers: headers,
                                    supportPageIndex: supportPageIndex,
                                    linkQueryString: linkQueryString,
                                    onClick: onLinksClick,
                                    sidebarContent: supportPage === null || supportPage === void 0 ? void 0 : supportPage.sidebarContent,
                                    currentSupportPage: supportPage._id
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                            className: "md:col-span-8 lg:col-span-9",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_serializeBlockContent__WEBPACK_IMPORTED_MODULE_8__/* .Prose */ .Mr, {
                                    content: supportPage.localeContent ? supportPage.localeContent : supportPage.content
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Integration, {
                                    type: supportPage.integration
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_CustomerSupportBanner__WEBPACK_IMPORTED_MODULE_13__/* .CustomerSupportBanner */ .j, {})
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 52938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getContentInputQuery; }
/* harmony export */ });
/* harmony import */ var hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95967);

/**
 *
 * This function generates a formatted input object for content groq queries, including the query string, source, parameters, and preview status.
 *
 */ var getContentInputQuery = function(param) {
    var query = param.query, context = param.context, params = param.params;
    return {
        input: {
            query: query.replace(/[\n]+/g, "").replace(/\s\s+/g, ""),
            src: context.query.src,
            params: params,
            draft: context.query.draft,
            preview: (0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_0__/* .groqPreviewInput */ .i8)(context.query)
        }
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1489,9294,2042,6740,769,9774,2888,179], function() { return __webpack_exec__(97968); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);